import { PropsWithChildren } from 'react';

interface LoadingIndicatorProps extends PropsWithChildren {
  styles?: string;
  dims?: string;
  additionalStyles?: string;
}

const LoadingIndicator = ({
  styles = 'rounded-full border-t-4 border-r border-l-4 border-b border-primary-500 dark:border-primary-900 mx-auto animate-spin',
  additionalStyles,
  dims = '~w-4/7 ~min-h-4/7',
  children
}: LoadingIndicatorProps) => {
  return (
    <div
      className={`flex items-center justify-center ~gap-2/4 ${additionalStyles}`}>
      <div className={`${dims} ${styles}`}></div>
      {children}
    </div>
  );
};

export default LoadingIndicator;
